import * as React from 'react';
import { Modal, ModalFooter, Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Form } from '@grandvisionhq/forms';

const PersonalDetails = (props)=>{
    var ref;
    const { email , isUpdating , showIntro , formState , personalDetailsData , showEditButton , handleFormChange , handleSavePersonalDetails , closeEditMode , toggleEditMode , labels , hasNoData , Slots ,  } = props;
    const { form: FormTemplate , summary: SummaryTemplate  } = Slots;
    if (!FormTemplate) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "personal-details"
    }, showIntro && /*#__PURE__*/ React.createElement(Text, null, labels.intro), /*#__PURE__*/ React.createElement(Modal, {
        isOpen: !!(formState === null || formState === void 0 ? void 0 : formState.inEditMode),
        onModalClose: closeEditMode,
        showIcon: true,
        title: labels.modalTitle,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            ctaCaption: labels.save,
            onCta: handleSavePersonalDetails,
            ctaLoading: isUpdating,
            onCancel: closeEditMode
        }),
        className: "personal-details__modal"
    }, /*#__PURE__*/ React.createElement(Text, null, labels.modalInfo), /*#__PURE__*/ React.createElement(Form, {
        name: "personalDetails",
        "data-t": "personalDetails",
        initialFormState: formState === null || formState === void 0 ? void 0 : (ref = formState.state) === null || ref === void 0 ? void 0 : ref.formState,
        onChange: handleFormChange
    }, /*#__PURE__*/ React.createElement(FormTemplate, null)), /*#__PURE__*/ React.createElement("div", {
        className: "personal-details__email"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "form-control__label"
    }, labels.email), /*#__PURE__*/ React.createElement("div", null, email)), /*#__PURE__*/ React.createElement(Text, null, labels.contact)), hasNoData ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, labels.noDetails), showEditButton && /*#__PURE__*/ React.createElement(Button, {
        caption: labels.add,
        onClick: toggleEditMode
    })) : null, SummaryTemplate && !hasNoData ? /*#__PURE__*/ React.createElement(SummaryTemplate, {
        values: personalDetailsData,
        email: email,
        actions: {
            onEdit: showEditButton ? toggleEditMode : undefined
        }
    }) : null);
};

export { PersonalDetails as default };
//# sourceMappingURL=PersonalDetails.js.map
